import type { AnnouncementMarkAllAsReadResponseType } from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { isApiV2ContextReady } from "../apiV2QueryScope";
import { ServerStateKeys } from "../ServerStateKeys";

export const useAnnouncementMarkAllAsRead = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();
  const canMarkAsRead = isApiV2ContextReady({
    scope: "buyerMember",
    user,
    business,
  });

  return useMutation({
    mutationFn: async () => {
      if (!canMarkAsRead) return { markedCount: 0 };
      return apiV2Request({
        user,
        business,
        method: "post",
        path: `announcements/mark-all-read`,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as AnnouncementMarkAllAsReadResponseType,
      );
    },

    onSuccess: () => {
      if (!canMarkAsRead) return;
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Announcements],
      });
    },
  });
};
